"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackLogType = void 0;
var TrackLogType;
(function (TrackLogType) {
    TrackLogType["Neutral"] = "neutral";
    TrackLogType["Good"] = "good";
    TrackLogType["Warning"] = "warning";
    TrackLogType["Critical"] = "critical";
})(TrackLogType || (exports.TrackLogType = TrackLogType = {}));
